// extracted by mini-css-extract-plugin
export var columnList = "_aa-0";